/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckFilters = {
  metadataReason?: Array<TaskMetadataReason> | null | undefined;
  priority?: Array<number> | null | undefined;
  type?: Array<TaskType> | null | undefined;
};

export type TaskMetadataReason =
  | "BBD"
  | "BBD_MISSING"
  | "DROPPING"
  | "EOY_INVENTORY"
  | "EOY_INVENTORY_RECOUNT"
  | "EXPENSIVE"
  | "EXTRA"
  | "FRESHNESS"
  | "INVENTORY_DISCREPANCY"
  | "LOW_STOCK"
  | "MISSING"
  | "ROLLING_8_WEEKS"
  | "ROLLING_12_WEEKS"
  | "ROLLING_INVENTORY"
  | "SPONTANEOUS_CORRECTION"
  | "TOBACCO";

export type TaskType =
  | "BBD_CHECK"
  | "EOY_INVENTORY_CHECK"
  | "EOY_INVENTORY_RECOUNT_CHECK"
  | "FRESHNESS_CHECK"
  | "INVENTORY_DISCREPANCY_CHECK"
  | "STOCK_CHECK";

export type GetPendingCheckCountQueryVariables = Exact<{
  input?: Types.CheckFilters | null | undefined;
}>;

export type GetPendingCheckCountQuery = {
  getOpenedChecksCountForHub: { checkCount: number | null };
};

export const GetPendingCheckCountDocument = gql`
  query GetPendingCheckCount($input: CheckFilters) {
    getOpenedChecksCountForHub(input: $input) {
      checkCount: pendingChecksCount
    }
  }
`;

/**
 * __useGetPendingCheckCountQuery__
 *
 * To run a query within a React component, call `useGetPendingCheckCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCheckCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCheckCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPendingCheckCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPendingCheckCountQuery,
    GetPendingCheckCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPendingCheckCountQuery, GetPendingCheckCountQueryVariables>(
    GetPendingCheckCountDocument,
    options,
  );
}
export function useGetPendingCheckCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingCheckCountQuery,
    GetPendingCheckCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPendingCheckCountQuery, GetPendingCheckCountQueryVariables>(
    GetPendingCheckCountDocument,
    options,
  );
}
// @ts-ignore
export function useGetPendingCheckCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingCheckCountQuery,
    GetPendingCheckCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPendingCheckCountQuery, GetPendingCheckCountQueryVariables>;
export function useGetPendingCheckCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingCheckCountQuery,
        GetPendingCheckCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPendingCheckCountQuery | undefined,
  GetPendingCheckCountQueryVariables
>;
export function useGetPendingCheckCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingCheckCountQuery,
        GetPendingCheckCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPendingCheckCountQuery, GetPendingCheckCountQueryVariables>(
    GetPendingCheckCountDocument,
    options,
  );
}
export type GetPendingCheckCountQueryHookResult = ReturnType<typeof useGetPendingCheckCountQuery>;
export type GetPendingCheckCountLazyQueryHookResult = ReturnType<
  typeof useGetPendingCheckCountLazyQuery
>;
export type GetPendingCheckCountSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingCheckCountSuspenseQuery
>;
export type GetPendingCheckCountQueryResult = Apollo.QueryResult<
  GetPendingCheckCountQuery,
  GetPendingCheckCountQueryVariables
>;
